module.exports = __webpack_public_path__ + "img/ktb_avator-1.930b142a.png";